'use client';

import { createContext, ReactNode } from 'react';
import { IosNotificationInstructionsDialogProvider } from './IosNotificationInstructionsDialogContext';
import { IosNotificationInstructionsDialog } from '../dialogs/IosNotificationInstructionsDialog';
import { NotificationBlockedDialog } from '../dialogs/NotificationBlockedDialog';
import { usePushSubscription } from '../hooks/usePushSubscription';

interface PushNotificationContextType {
  isSupported: boolean;
  isSubscribing: boolean;
  pushPermission: NotificationPermission;
  showDeniedDialog: boolean;
  setShowDeniedDialog: (show: boolean) => void;
  subscribeToPush: () => Promise<{
    success: boolean;
    reason?:
      | 'ios-limitation'
      | 'permission-denied'
      | 'error'
      | 'desktop-dialog';
  }>;
  updatePushSubscription: () => Promise<void>;
}

export const PushNotificationContext =
  createContext<PushNotificationContextType | null>(null);

function PushNotificationState({ children }: { children: ReactNode }) {
  const pushSubscription = usePushSubscription();

  return (
    <PushNotificationContext value={pushSubscription}>
      {children}
      <IosNotificationInstructionsDialog />
      <NotificationBlockedDialog />
    </PushNotificationContext>
  );
}

export function PushNotificationProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <IosNotificationInstructionsDialogProvider>
      <PushNotificationState>{children}</PushNotificationState>
    </IosNotificationInstructionsDialogProvider>
  );
}
